import { useQuery } from "@tanstack/react-query";
import servicePriceService from "..";

const useGetServicePrices = () =>
  useQuery({
    queryKey: ["get-service-price"],
    queryFn: () => servicePriceService.getServicePrices(),
    select: (res) => res,
  });

export { useGetServicePrices };
